import { useSearchStore } from '../../stores/search-store.js';
import { useBarClause } from '../../hooks/useBarClause.js';
import { useSymbolMap } from '../../hooks/useSymbolMap.js';

const SYMBOLS = [
  '{W}', '{U}', '{B}', '{R}', '{G}', '{C}', '{X}',
  '{0}', '{1}', '{2}', '{3}', '{4}', '{5}', '{6}', '{7}', '{8}', '{9}',
];

export function ManaCostBuilder() {
  const manaCost = useSearchStore((s) => s.advancedFilters.manaCost);
  const setAdvancedFilter = useSearchStore((s) => s.setAdvancedFilter);
  const { writeClause } = useBarClause();
  const symbolMap = useSymbolMap();

  const addSymbol = (sym: string) => {
    const newCost = manaCost + sym;
    setAdvancedFilter('manaCost', newCost);
    writeClause('m:', newCost);
  };

  const removeLastSymbol = () => {
    const match = manaCost.match(/^(.*)\{[^}]*\}$/);
    const newCost = match?.[1] ?? '';
    setAdvancedFilter('manaCost', newCost);
    writeClause('m:', newCost || null);
  };

  const clear = () => {
    setAdvancedFilter('manaCost', '');
    writeClause('m:', null);
  };

  // Render the preview as mana symbol images
  const previewSymbols = manaCost.match(/\{[^}]+\}/g) ?? [];

  return (
    <div className="space-y-1.5">
      <label className="text-[10px] text-gray-500 uppercase tracking-wider">Mana Cost</label>

      {/* Symbol palette */}
      <div className="flex flex-wrap gap-1">
        {SYMBOLS.map((sym) => {
          const svgUri = symbolMap[sym];
          return (
            <button
              key={sym}
              onClick={() => addSymbol(sym)}
              className="w-7 h-7 rounded flex items-center justify-center bg-gray-800 border border-gray-700 hover:border-orange-500 transition-colors"
              title={sym}
            >
              {svgUri ? (
                <img src={svgUri} alt={sym} className="w-4 h-4" />
              ) : (
                <span className="text-[10px] font-bold text-gray-400">{sym.replace(/[{}]/g, '')}</span>
              )}
            </button>
          );
        })}
      </div>

      {/* Preview */}
      {manaCost && (
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-0.5 flex-1">
            {previewSymbols.map((sym, i) => {
              const svgUri = symbolMap[sym];
              return svgUri
                ? <img key={i} src={svgUri} alt={sym} className="w-4 h-4" />
                : <span key={i} className="text-xs text-gray-400">{sym}</span>;
            })}
          </div>
          <button
            onClick={removeLastSymbol}
            className="text-[10px] text-gray-500 hover:text-gray-300 px-1.5 py-0.5 bg-gray-800 border border-gray-700 rounded transition-colors"
            title="Backspace"
          >
            Bksp
          </button>
          <button
            onClick={clear}
            className="text-[10px] text-gray-500 hover:text-red-400 px-1.5 py-0.5 bg-gray-800 border border-gray-700 rounded transition-colors"
            title="Clear"
          >
            Clear
          </button>
        </div>
      )}
    </div>
  );
}
